const createSignatureStorageKey = () =>
  `signed_contract_print_${Date.now()}_${Math.random()
    .toString(36)
    .substring(2, 11)}`;

export const openSignedRecycleOrderContract = ({
  orderIdList,
  signatureImage,
}: {
  orderIdList: string[];
  signatureImage: string;
}) => {
  const uniqueOrderIdList = Array.from(new Set(orderIdList.filter(Boolean)));
  if (!uniqueOrderIdList.length) return;

  const signatureKey = createSignatureStorageKey();
  sessionStorage.setItem(signatureKey, signatureImage);

  const searchParams = new URLSearchParams();
  searchParams.set('orderIdList', uniqueOrderIdList.join(','));
  searchParams.set('contractType', 'normal');
  searchParams.set('sendContract', '1');
  searchParams.set('signatureKey', signatureKey);

  window.open(`/prints/oms-recycle-order-contract?${searchParams.toString()}`);
};
